import { render, staticRenderFns } from "./SupplierTypeModalForm.vue?vue&type=template&id=dfae67e4"
import script from "./SupplierTypeModalForm.vue?vue&type=script&lang=js"
export * from "./SupplierTypeModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports